// Builds the optimistic user bubble shown while the send request is in flight. It
// carries isUITemp so useMessages can drop it once the stored message comes back.
const buildPendingUserMessage = (messages, plainText) => ({
  id: messages.length > 0 ? messages[messages.length - 1].id + 1 : 0,
  isUITemp: true,
  createdAt: Date.now(),
  content: {
    text: `<p>${plainText.replaceAll("\"", "\\\"").replaceAll("\n", "<br/>")}</p>`,
    plain: `${plainText.replaceAll("\"", "\\\"")}`,
  },
  action: {},
  type: "USER_MESSAGE",
});

// Execution variables travel to the backend inside chat_options.params.
const buildChatOptions = (executionVariables, extraOptions = {}) => {
  const options = { ...extraOptions };
  if (executionVariables && Object.keys(executionVariables).length > 0)
    options.params = executionVariables;
  return options;
};

export { buildChatOptions, buildPendingUserMessage };
